import { useEffect } from 'react';
import { type Location, useLocation, useNavigate } from 'react-router-dom';
import Loading from '../_tools/Loading';
import { betterUseNavigate, encodeDecodeURIComponent } from '../_tools/Tools';

const LoginUWE = () => {
    const loc: Location & { state: { [index: string]: string | number | boolean } } = useLocation();
    const navigate = useNavigate();

    useEffect(function () {
        const pairs = loc?.search?.slice(1).split('&');
        const result: any = {};
        pairs.forEach(function (pair: string) {
            const newPair = pair.split('=');
            result[newPair[0]] = newPair[1] || '';
        });
        betterUseNavigate(navigate, loc?.state, { replace: false, pathname: '/loginr', state: { enc: result.enc, redir: encodeDecodeURIComponent(result.redir, true) } }, false);
    }, []);

    return <Loading />;
};

export default LoginUWE;
